<template>
  <component :is="element" class="swiper-slide" :style="cssProps">
    <slot />
  </component>
</template>
<script>
import { defineComponent, computed, inject } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    element: {
      type: String,
      default: 'div',
    },
  },
  setup() {
    const settings = inject('swiperSettings');
    const cssProps = computed(() => ({
      ...(settings.slidesPerView !== 'auto' && {
        width: `calc((100% - (${(settings.slidesPerView || 1) - 1}) * ${settings.spaceBetween || 0}px) / ${settings.slidesPerView || 1})`,
      }),
      ...(settings.slidesPerView !== 'auto' && settings.spaceBetween && { marginLeft: settings.spaceBetween + 'px' }),
    }));
    return { cssProps };
  },
});
</script>
